import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { Button, Col, Form, Input, message, Popconfirm, Row, Select, Space, Tooltip } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { convertFieldsToFloat } from "../../extensions/utils";
import { isMobile } from "@/extensions/design";

const StockDocCnt = ({ onClose, itemDefault, products, vid }) => {
  const [item, setItem] = useState({...itemDefault});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (!itemDefault.id) {
      setItem(itemDefault);
      form.setFieldsValue(itemDefault);
    }
    else {
      setLoading(true);
      serverFetch(`store/DocCnt/${itemDefault.id}`)
        .then(data => {
          setItem(data);
          setLoading(false);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
  }

  useEffect(getData, [itemDefault]);

  const isQtyFactEmpty = (qtyFact) => {
    if (qtyFact === null || qtyFact === undefined) return true;
    if (typeof qtyFact === "string" && qtyFact.trim() === "") return true;
    return false;
  };

  const parseNum = (v, fallback = 0) => {
    const n = Number.parseFloat(v);
    return Number.isFinite(n) ? n : fallback;
  };

  /** Сумма: при пустом факт. кол. — qty * coeff * price, иначе qtyFact * coeff * price */
  const getSyma = (qty, qtyFact, coeff, price) => {
    const c = parseNum(coeff, 0);
    const p = parseNum(price, 0);
    const baseQty = isQtyFactEmpty(qtyFact) ? parseNum(qty, 0) : parseNum(qtyFact, 0);
    return baseQty * c * p;
  };

  const onValuesChange = value => {
    const newItem = { ...item, ...value };
    if (value.productId){
      serverFetch(`product/${newItem.productId}`)
        .then(data => {
          if (vid === 1) {
            newItem.coeff = data.putCoeff ?? 1;
            newItem.price = data.putPrice ?? 0;
            newItem.productUnit = vid === 1 ? data.putUnit : data.expUnit;
          }
          else if (vid === -1) {
            newItem.coeff = data.expCoeff ?? 1;
            newItem.price = data.expPrice ?? 0;
            newItem.productUnit = data.expUnit;
          }
          else {
            newItem.productUnit = data.expUnit;
            newItem.price = data.expPrice ?? 0;
          }
          newItem.syma = getSyma(newItem.qty, newItem.qtyFact, newItem.coeff, newItem.price);
          setItem(newItem);
          form.setFieldsValue(newItem);
        })
        .catch(e => {
          message.error(e.userMessage);
        })
    }
    else {
      //newItem.coeff = products.find(i => i.value === value.productId)?.putCoeff ?? 1;
      newItem.syma = getSyma(newItem.qty, newItem.qtyFact, newItem.coeff, newItem.price);
      setItem(newItem);
      form.setFieldsValue(newItem);
    }
  }

  const onDelete = () => {
    setLoading(true)
    serverFetch(`store/DocCnt/${item.id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onSave = () => {
    setLoading(true);
    const newItem = convertFieldsToFloat(item,["qty","qtyFact"]);
    serverFetch(`store/DocCnt`, {method : item.id ? "PUT" : "POST", bodyData: newItem})
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }
  const onCancel = () => onClose(false)

  const canSave = (item?.qtyFact ?? 0) >= 0;
  const effectiveVid = vid ?? item?.storeDocVid ?? itemDefault?.storeDocVid;
  const productQtyRest = products.find((p) => p.value === item?.productId)?.qtyRest;
  const qtyValue = Number.parseFloat(item?.qty);
  const qtyRestValue = Number.parseFloat(productQtyRest);
  const normalizedQty = Number.isFinite(qtyValue) ? qtyValue : 0;
  const normalizedQtyRest = Number.isFinite(qtyRestValue) ? qtyRestValue : 0;
  // Для расхода показываем остаток только у новых строк.
  const showQtyRest = !Boolean(item?.id) && (effectiveVid === -1 || item?.qtyRest !== undefined);
  const showQtyWarning = showQtyRest && normalizedQty > normalizedQtyRest;

  const containerClass = !item?.id ? "client-item-line-triple-halfed" : "client-item-line-double-halfed";

  return !isMobile ? (<div>
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
      <Form.Item label="Товар" name="productId"><Select options={products}/></Form.Item>
      <Form.Item label="Количество">
        <Row>
          <Col span={8}><Form.Item name="qty"><Input suffix={showQtyWarning ? <Tooltip title="Количество меньше остатка"><WarningOutlined style={{ color: "#faad14" }} /></Tooltip> : null} /></Form.Item></Col>
          <Col span={2}/>
          <Col span={14}><Form.Item name="qtyFact" label="Факт. кол." labelCol={{ span: 10 }}><Input /></Form.Item></Col>
        </Row>     
      </Form.Item> 
      {showQtyRest && <Form.Item label="Остаток"><Input value={normalizedQtyRest} disabled /></Form.Item>}
      <Form.Item label="Коэффициент">
        <Row>
          <Col span={8}><Form.Item name="coeff"><Input /></Form.Item></Col>
          <Col span={2}/>
          <Col span={14}><Form.Item name="productUnit" label="Единица" labelCol={{ span: 10 }}><Input disabled/></Form.Item></Col>
        </Row>     
      </Form.Item>       
      <Form.Item label="Цена">
        <Row>
          <Col span={8}>
            <Form.Item name="price"><Input /></Form.Item>
          </Col>
          <Col span={2}/>
          <Col span={14}>
            <Form.Item label="Сумма" name="syma" labelCol={{ span: 10 }}><Input disabled/></Form.Item>
          </Col>
        </Row>     
      </Form.Item> 
      <Form.Item label=" ">
        <Space>
          <Button className="sport-btn" onClick={onSave} disabled={!item.productId || !canSave}>Сохранить</Button>
          <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}>
            <Button className="sport-btn" disabled={!item.id}>Удалить</Button>
          </Popconfirm>
          <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
        </Space>
      </Form.Item>
    </Form>
  </div>) : 
  (<>
  <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 2 }} colon={false} disabled={loading} layout="inline">
      <Form.Item label="Товар" name="productId" className="record-form-item-with-margin-top-mobile">
        <Select className="records-form-item-mobile" options={products}/>
      </Form.Item>
      <Form.Item className="records-form-item-mobile" label="Кол-во">
        <Row align="middle" className="records-row-mobile">
          <Col>
            <Form.Item name="qty" className="record-form-item-with-margin-top-mobile">
              <Input className="records-small-input-mobile" suffix={showQtyWarning ? <Tooltip title="Количество меньше остатка"><WarningOutlined style={{ color: "#faad14" }} /></Tooltip> : null} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Факт.кол-во" name="qtyFact" className="record-form-item-with-margin-top-mobile">
              <Input className="records-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      {showQtyRest && <Form.Item className="records-form-item-mobile" label="Остаток"><Input value={normalizedQtyRest} disabled className="records-small-input-mobile" /></Form.Item>}
      <Form.Item className="records-form-item-mobile" label="Коэфф.">
        <Row align="middle" className="records-row-mobile">
          <Col>
            <Form.Item name="coeff" className="record-form-item-with-margin-top-mobile">
              <Input className="records-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Ед." name="productUnit" className="record-form-item-with-margin-top-mobile">
              <Input disabled className="records-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>  

      <Form.Item className="records-form-item-mobile" label="Цена">
        <Row align="middle" className="records-row-mobile">
          <Col>
            <Form.Item name="price" className="record-form-item-with-margin-top-mobile">
              <Input className="records-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Сумма" name="syma" className="record-form-item-with-margin-top-mobile">
              <Input disabled className="records-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <div className={containerClass} style={{marginTop: "4px", paddingRight: "0px"}}>
        <Button onClick={onSave} disabled={!item.productId || !canSave}>Сохранить</Button>
        <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}
          placement="top" getPopupContainer={(trigger) => trigger.closest(`.${containerClass}`)} overlayClassName="centered-popconfirm">
          <Button disabled={!item.id}>Удалить</Button>
        </Popconfirm>
        {!item?.id ? <Button onClick={onCancel}>Отмена</Button> : <></>}
      </div>
    </Form>
  </>)
}

export default StockDocCnt;